module.exports = __webpack_public_path__ + "static/media/header-text.6e645b23.png";